import apis from "../../apis/api.actions";

export const getDynTable = (data) => apis.getDatas(data).then((res) => res);

export const delete_submodule = (data) =>
  apis.createData("/sync-relations/?delete=true", data).then((res) => res);
